<ng-container *transloco="let t; prefix: scope">
  <div class="flex flex-col" [formGroup]="formGroup">
    <h4 class="font-semibold">{{ t('payingPartTitle') }}</h4>
    <bl-frontend-radiobuttons
      name="paying-part"
      [items]="radioButtonsItems"
      [bordered]="true"
      formControlName="payingPart"
      (valueChanged)="revalidateForm()"></bl-frontend-radiobuttons>
    <div class="mt-4" *ngIf="showClientInformationSection()">
      <ng-container
        *ngTemplateOutlet="
          clientPayingFormTemplate;
          context: { $implicit: formGroup.get('clientInformation') }
        "></ng-container>
    </div>
    <div class="mt-6">
      <bl-frontend-loading-button
        [text]="t('save')"
        variant="tonal"
        (onclick)="updatePayingPart()"
        [loading]="saving()"
        [pTooltip]="updatePayingPartDisabledTooltip()"
        [disabled]="
          isCollaboratorFirm() === true || !formGroup.valid || !formGroup.touched
        "></bl-frontend-loading-button>
    </div>
  </div>

  <ng-template #clientPayingFormTemplate let-formGroup>
    <div [formGroup]="formGroup">
      <div class="flex flex-col mt-4">
        <bl-frontend-text-input name="reference" formControlName="reference" [text]="t('reference')"></bl-frontend-text-input>
      </div>
      <div class="flex flex-col mt-4">
        <bl-frontend-email-input name="email" formControlName="email" [text]="t('emailForInvoices')"></bl-frontend-email-input>
      </div>
      <div class="flex flex-col mt-4">
        <bl-frontend-phone-input name="phoneNumber" formControlName="phoneNumber" [text]="t('phone')"></bl-frontend-phone-input>
      </div>
      <div class="mt-4">
        <p class="text-sm" [innerHTML]="t('acceptPaymentTermsText')"></p>
        <bl-frontend-checkbox
          formControlName="acceptPaymentTerms"
          [text]="t('acceptPaymentTermsLabel')"></bl-frontend-checkbox>
        <bl-frontend-checkbox
          formControlName="acceptInformedClient"
          [useUnsafeHtml]="true"
          [text]="t('acceptInformedClientLabel')"></bl-frontend-checkbox>
      </div>
    </div>
  </ng-template>
</ng-container>
